module.exports = __webpack_public_path__ + "static/media/SPRAT4.d5123777.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAT4.png
// module id = 277
// module chunks = 0